import { Injectable } from '@angular/core';
import { Headers, Request, Response, RequestMethod, RequestOptionsArgs, RequestOptions } from '@angular/http';
import { HttpHelper } from '../helpers/http.helper';
import { environment } from '../../../environments/environment';

@Injectable()
export class DateService {

    constructor(private _httpHelper: HttpHelper) {
    }

    public getCurrentDate(dateFormat = 'yyyy/mm/dd') {
        let todayDate: any = new Date(),
            month = '' + (todayDate.getMonth() + 1),
            day = '' + todayDate.getDate(),
            year = todayDate.getFullYear();
        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        if (dateFormat == 'mm/dd/yyyy') {
            todayDate = [month, day, year].join('/');
        } else if (dateFormat == 'dd/mm/yyyy') {
            todayDate = [day, month, year].join('/');
        } else {
            todayDate = [year, month, day].join('-');
        }
        return todayDate;
    }

    public getPreviousDate(dateFormat = 'yyyy/mm/dd') {
        let todayDate: any = new Date(),
            fromDate = todayDate.setDate(todayDate.getDate() - 1),
            month = '' + (todayDate.getMonth() + 1),
            day = '' + todayDate.getDate(),
            year = todayDate.getFullYear();
        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        fromDate = [year, month, day].join('/');

        if (dateFormat == 'mm/dd/yyyy') {
            fromDate = [month, day, year].join('/');
        } else if (dateFormat == 'dd/mm/yyyy') {
            fromDate = [day, month, year].join('/');
        }
        return fromDate;
    }

    public getLastWeekDate(dateFormat = 'yyyy/mm/dd') {
        let todayDate: any = new Date(),
            fromDate = todayDate.setDate(todayDate.getDate() - 7),
            month = '' + (todayDate.getMonth() + 1),
            day = '' + todayDate.getDate(),
            year = todayDate.getFullYear();
        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        fromDate = [year, month, day].join('/');

        if (dateFormat == 'mm/dd/yyyy') {
            fromDate = [month, day, year].join('/');
        } else if (dateFormat == 'dd/mm/yyyy') {
            fromDate = [day, month, year].join('/');
        }
        return fromDate;
    }

    public getDateTimeFromTimestamp(timestamp: number) {
        let date = new Date(timestamp * 1000);
        let dateTimeString = "";
        if (date.getMonth() < 9) {
            dateTimeString += "0";
        }
        dateTimeString += (date.getMonth() + 1);
        dateTimeString += "/";
        if (date.getDate() < 10) {
            dateTimeString += "0";
        }
        dateTimeString += date.getDate();
        dateTimeString += "/" + date.getFullYear();
        dateTimeString += " ";
        let hours: any = date.getHours();
        let minutes: any = date.getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        hours = hours < 10 ? '0' + hours : hours;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        let timeString = hours + ':' + minutes + ' ' + ampm;
        dateTimeString += timeString;
        return dateTimeString;
    }


    public getDateFromDateTimeString(dateString: any, dateFormat: string = 'dd/mm/yyy', dateSeperator: string = '-') {
        var date = new Date(dateString);
        if (dateFormat == 'mm/dd/yyyy') {
            return ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + dateSeperator + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + dateSeperator + date.getFullYear();
        } else if (dateFormat == 'dd/mm/yyyy') {
            return ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + dateSeperator + ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + dateSeperator + date.getFullYear();
        } else {
            return date.getFullYear() + dateSeperator + ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + dateSeperator + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate()));
        }
    }

    public getDaysFromGivenDate(dateString: any) {
        let todayDate: any = new Date(),
            currentMonth = (todayDate.getMonth() + 1),
            currentDay = todayDate.getDate(),
            currentYear = todayDate.getFullYear();

        let previousDate = new Date(dateString),
            previousMonth = (previousDate.getMonth() + 1),
            previousDay = previousDate.getDate(),
            previousYear = previousDate.getFullYear();

        return (currentYear - previousYear) * 365 + (currentMonth - previousMonth) * 30 + (currentDay - previousDay)
    }

    isSameDateInTimezone(givenDate: Date, timeZone: string): boolean {
        // Get the current date in the specified time zone
        const formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: timeZone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });

        // Format both dates to the same format (YYYY-MM-DD) for comparison
        const givenDateStr = formatter.format(givenDate);
        const currentDateStr = formatter.format(new Date());

        // Compare the formatted dates
        return givenDateStr === currentDateStr;
    }
}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/common/services/date.service.ts